import { Box, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import take from 'lodash/take'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  items: string[]
  maxItemsToDisplay: number
}

const NamesToDisplay = ({ items, maxItemsToDisplay }: Props) => {
  const [open, toggle] = useToggle(false)

  const totalCount = items.length
  const showTooltip = totalCount > maxItemsToDisplay

  const visibleItems = take(items, maxItemsToDisplay).join(', ')
  const itemsForTooltip = items.slice(maxItemsToDisplay).join(', ')
  const countForTooltip = items.length - maxItemsToDisplay

  return (
    <Box>
      {showTooltip ? (
        <Text.Normal size="300" color="grey1000">
          {visibleItems}&nbsp;
          <Tooltip.Alt
            attachment="top center"
            open={open}
            toggle={toggle}
            label={itemsForTooltip}
            inline
          >
            <Text.Normal size="300" color="grey1000" dotted>
              {i18n.t('shift_management.add_shift.and_more', {
                count: countForTooltip,
              })}
            </Text.Normal>
          </Tooltip.Alt>
        </Text.Normal>
      ) : (
        <Text.Normal size="300" color="grey1000">
          {items.join(', ')}
        </Text.Normal>
      )}
    </Box>
  )
}

export default observer(NamesToDisplay)
